<template>
  <div id="map" class="maps"></div>
</template>
<script>
let echarts = require('echarts');
import mapdata from '@/util/map';
import { provs_data, citys_data, dists_data } from '../../../../static/city.js';
export default {
  name: 'maps',
  data() {
    return {
      mapName: 'china',
      geoCoordMap: {},
      data: [
        {
          name: '北京',
          value: 0,
        },
        {
          name: '天津',
          value: 0,
        },
        {
          name: '河北',
          value: 0,
        },
        {
          name: '山西',
          value: 0,
        },
        {
          name: '内蒙古',
          value: 0,
        },
        {
          name: '辽宁',
          value: 0,
        },
        {
          name: '吉林',
          value: 0,
        },
        {
          name: '黑龙江',
          value: 0,
        },
        {
          name: '上海',
          value: 0,
        },
        {
          name: '江苏',
          value: 0,
        },
        {
          name: '浙江',
          value: 0,
        },
        {
          name: '安徽',
          value: 0,
        },
        {
          name: '福建',
          value: 0,
        },
        {
          name: '江西',
          value: 0,
        },
        {
          name: '山东',
          value: 0,
        },
        {
          name: '河南',
          value: 0,
        },
        {
          name: '湖北',
          value: 0,
        },
        {
          name: '湖南',
          value: 0,
        },
        {
          name: '重庆',
          value: 0,
        },
        {
          name: '四川',
          value: 0,
        },
        {
          name: '贵州',
          value: 0,
        },
        {
          name: '云南',
          value: 0,
        },
        {
          name: '西藏',
          value: 0,
        },
        {
          name: '陕西',
          value: 0,
        },
        {
          name: '甘肃',
          value: 0,
        },
        {
          name: '青海',
          value: 0,
        },
        {
          name: '宁夏',
          value: 0,
        },
        {
          name: '新疆',
          value: 0,
        },
        {
          name: '广东',
          value: 0,
        },
        {
          name: '广西',
          value: 0,
        },
        {
          name: '海南',
          value: 0,
        },
      ],
      toolTipData: [
        {
          name: '北京',
          value: [
            {
              name: '项目数量',
              value: 95,
            },
            {
              name: '公司数量',
              value: 82,
            },
            {
              name: '专家数量',
              value: 82,
            },
          ],
        },
        {
          name: '天津',
          value: [
            {
              name: '项目数量',
              value: 22,
            },
            {
              name: '公司数量',
              value: 20,
            },
          ],
        },
        {
          name: '河北',
          value: [
            {
              name: '项目数量',
              value: 60,
            },
            {
              name: '公司数量',
              value: 42,
            },
          ],
        },
        {
          name: '山西',
          value: [
            {
              name: '项目数量',
              value: 40,
            },
            {
              name: '公司数量',
              value: 41,
            },
          ],
        },
        {
          name: '内蒙古',
          value: [
            {
              name: '项目数量',
              value: 23,
            },
            {
              name: '公司数量',
              value: 24,
            },
          ],
        },
        {
          name: '辽宁',
          value: [
            {
              name: '项目数量',
              value: 39,
            },
            {
              name: '公司数量',
              value: 28,
            },
          ],
        },
        {
          name: '吉林',
          value: [
            {
              name: '项目数量',
              value: 41,
            },
            {
              name: '公司数量',
              value: 41,
            },
          ],
        },
        {
          name: '黑龙江',
          value: [
            {
              name: '项目数量',
              value: 35,
            },
            {
              name: '公司数量',
              value: 31,
            },
          ],
        },
        {
          name: '上海',
          value: [
            {
              name: '项目数量',
              value: 12,
            },
            {
              name: '公司数量',
              value: 12,
            },
          ],
        },
        {
          name: '江苏',
          value: [
            {
              name: '项目数量',
              value: 47,
            },
            {
              name: '公司数量',
              value: 45,
            },
          ],
        },
        {
          name: '浙江',
          value: [
            {
              name: '项目数量',
              value: 57,
            },
            {
              name: '公司数量',
              value: 57,
            },
          ],
        },
        {
          name: '安徽',
          value: [
            {
              name: '项目数量',
              value: 57,
            },
            {
              name: '公司数量',
              value: 52,
            },
          ],
        },
        {
          name: '福建',
          value: [
            {
              name: '项目数量',
              value: 59,
            },
            {
              name: '公司数量',
              value: 57,
            },
          ],
        },
        {
          name: '江西',
          value: [
            {
              name: '项目数量',
              value: 49,
            },
            {
              name: '公司数量',
              value: 42,
            },
          ],
        },
        {
          name: '山东',
          value: [
            {
              name: '项目数量',
              value: 67,
            },
            {
              name: '公司数量',
              value: 52,
            },
          ],
        },
        {
          name: '河南',
          value: [
            {
              name: '项目数量',
              value: 69,
            },
            {
              name: '公司数量',
              value: 68,
            },
          ],
        },
        {
          name: '湖北',
          value: [
            {
              name: '项目数量',
              value: 60,
            },
            {
              name: '公司数量',
              value: 56,
            },
          ],
        },
        {
          name: '湖南',
          value: [
            {
              name: '项目数量',
              value: 62,
            },
            {
              name: '公司数量',
              value: 52,
            },
          ],
        },
        {
          name: '重庆',
          value: [
            {
              name: '项目数量',
              value: 47,
            },
            {
              name: '公司数量',
              value: 44,
            },
          ],
        },
        {
          name: '四川',
          value: [
            {
              name: '项目数量',
              value: 65,
            },
            {
              name: '公司数量',
              value: 60,
            },
          ],
        },
        {
          name: '贵州',
          value: [
            {
              name: '项目数量',
              value: 32,
            },
            {
              name: '公司数量',
              value: 30,
            },
          ],
        },
        {
          name: '云南',
          value: [
            {
              name: '项目数量',
              value: 42,
            },
            {
              name: '公司数量',
              value: 41,
            },
          ],
        },
        {
          name: '西藏',
          value: [
            {
              name: '项目数量',
              value: 5,
            },
            {
              name: '公司数量',
              value: 4,
            },
          ],
        },
        {
          name: '陕西',
          value: [
            {
              name: '项目数量',
              value: 38,
            },
            {
              name: '公司数量',
              value: 42,
            },
          ],
        },
        {
          name: '甘肃',
          value: [
            {
              name: '项目数量',
              value: 28,
            },
            {
              name: '公司数量',
              value: 28,
            },
          ],
        },
        {
          name: '青海',
          value: [
            {
              name: '项目数量',
              value: 5,
            },
            {
              name: '公司数量',
              value: 5,
            },
          ],
        },
        {
          name: '宁夏',
          value: [
            {
              name: '项目数量',
              value: 10,
            },
            {
              name: '公司数量',
              value: 8,
            },
          ],
        },
        {
          name: '新疆',
          value: [
            {
              name: '项目数量',
              value: 36,
            },
            {
              name: '公司数量',
              value: 31,
            },
          ],
        },
        {
          name: '广东',
          value: [
            {
              name: '项目数量',
              value: 63,
            },
            {
              name: '公司数量',
              value: 60,
            },
          ],
        },
        {
          name: '广西',
          value: [
            {
              name: '项目数量',
              value: 29,
            },
            {
              name: '公司数量',
              value: 30,
            },
          ],
        },
        {
          name: '台湾',
          value: [
            {
              name: '项目数量',
              value: 8,
            },
            {
              name: '公司数量',
              value: 6,
            },
          ],
        },
        {
          name: '香港',
          value: [
            {
              name: '项目数量',
              value: 8,
            },
            {
              name: '公司数量',
              value: 6,
            },
          ],
        },
        {
          name: '澳门',
          value: [
            {
              name: '项目数量',
              value: 8,
            },
            {
              name: '公司数量',
              value: 6,
            },
          ],
        },
      ],
    };
  },
  props: {
    trans: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init2() {},
    init() {
      this.$request.post('/index/Map/MapIndex').then((res) => {
        this.data.forEach((v, i) => {
          // console.log("地图数据", res.mapInfo);
          this.toolTipData[i].value = [
            {
              name: '项目数量',
              value: 0,
            },
            {
              name: '公司数量',
              value: 0,
            },
            {
              name: '专家数量',
              value: 0,
            },
          ];
          let str = '';
          this.data[i].id = provs_data;
          provs_data.forEach((v3) => {
            if (v3.text.indexOf(this.data[i].name) != -1) {
              this.data[i].id = v3.value;
            }
          });
          res.mapInfo.forEach((v2) => {
            // console.log('789789',v2,v)

            if (v2.province.indexOf(v.name) != -1) {
              this.data[i].value = v2.ptXmNum * 1 + v2.xm_num * 1;
              this.toolTipData[i].value = [
                {
                  name: '项目数量',
                  value: v2.ptXmNum * 1 + v2.xm_num * 1,
                },
                {
                  name: '公司数量',
                  value: v2.ptCompanyNum * 1 + v2.expert_num * 1,
                },
                {
                  name: '专家数量',
                  value: v2.ptExpertNum * 1 + v2.xm_num * 1,
                },
              ];
            } else {
            }
          });
        });
        //初始化echarts实例
        let that = this;
        const myChart = echarts.init(document.getElementById('map'));
        myChart.on('click', function (params) {
          // alert(params.data.name + ':' + params.data.id);
          // 请求地址得到对应市的map.js 数据
          // https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=110000_full
          let id = '';
          provs_data.forEach((item) => {
            if (item.text.includes(params.name)) {
              id = item.value;
            }
          });
          that.$emit('updateMap', { data: { id } });
        });
        let option = {
          backgroundColor: this.trans ? 'transparent' : 'white',
          title: {
            text: '',
            subtext: '',
            x: 'center',
            textStyle: {
              // color: nameColor,
              // fontFamily: name_fontFamily,
              // fontSize: name_fontSize
            },
            subtextStyle: {
              // fontSize:subname_fontSize,
              // fontFamily:name_fontFamily
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              if (typeof params.value[2] == 'undefined') {
                var toolTiphtml = '';
                for (var i = 0; i < toolTipData.length; i++) {
                  if (params.name == toolTipData[i].name) {
                    toolTiphtml += `<div style='font-weight:1000;'>${toolTipData[i].name}</div>`;
                    for (var j = 0; j < toolTipData[i].value.length; j++) {
                      toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + '<br>';
                    }
                  }
                }
                // console.log(convertData(data))
                return toolTiphtml;
              } else {
                var toolTiphtml = '';
                for (var i = 0; i < toolTipData.length; i++) {
                  if (params.name == toolTipData[i].name) {
                    toolTiphtml += `<div style='font-weight:1000;'>${toolTipData[i].name}</div>`;
                    for (var j = 0; j < toolTipData[i].value.length; j++) {
                      toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + '<br>';
                    }
                  }
                }
                // console.log(convertData(data))
                return toolTiphtml;
              }
            },
          },
          visualMap: {
            show: false,
            min: 0,
            max: 700,
            left: 'left',
            top: 'bottom',
            text: ['高', '低'], // 文本，默认为数值文本
            calculable: true,
            seriesIndex: [1],
            inRange: {
              // color: ['#3B5077', '#031525'] // 蓝黑
              // color: ['#ffc0cb', '#800080'] // 红紫
              // color: ['#3C3B3F', '#605C3C'] // 黑绿
              // color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
              // color: ['#23074d', '#cc5333'] // 紫红
              color: ['#D8E1EC', '#5E79A8', '#335DA3', '#2362CD', '#094BB6'], // 蓝绿
              // color: ['#1488CC', '#2B32B2'] // 浅蓝
              // color: ['#00467F', '#A5CC82'] // 蓝绿
              // color: ['#00467F', '#A5CC82'] // 蓝绿
              // color: ['#00467F', '#A5CC82'] // 蓝绿
              // color: ['#00467F', '#A5CC82'] // 蓝绿
            },
          },

          geo: {
            show: true,
            map: 'china',
            roam: false, // 设置允许缩放以及拖动的效果
            zoom: 1.2,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            // regions: [{
            // 	name: '广东',
            // 	itemStyle: {
            // 		areaColor: 'red',
            // 		color: 'red'
            // 	}
            // }],
            // roam: false,
            itemStyle: {
              normal: {
                areaColor: '#d1dbe8',
                borderColor: '#3B5077',
              },
              emphasis: {
                areaColor: 'transparent',
              },
            },
          },
          series: [
            {
              name: '散点',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: this.convertData(this.data),
              symbolSize: [10, 10],
              label: {
                normal: {
                  formatter(value) {
                    return value.name + ' ' + value.data.value[2];
                  },
                  position: 'right',
                  padding: [3, 8],
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.49)',
                  show: true,
                },
                emphasis: {
                  show: true,
                },
              },
              itemStyle: {
                normal: {
                  color: '#FFE11B',
                },
              },
            },
            {
              type: 'map',
              map: 'china',
              geoIndex: 0,
              aspectScale: 0.75, //长宽比
              showLegendSymbol: false, // 存在legend时显示
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#fff',
                    padding: [5, 10],
                    backgroundColor: 'rgba(0, 0, 0, 0.49)',
                  },
                },
                emphasis: {
                  show: false,
                  textStyle: {
                    color: '#fff',
                  },
                },
              },
              roam: true,
              itemStyle: {
                normal: {
                  areaColor: '#031525',
                  borderColor: '#3B5077',
                },
                emphasis: {
                  areaColor: '#2B91B7',
                },
              },
              animation: false,
              // data: this.data
            },
          ],
        };
        //使用制定的配置项和数据显示图表
        myChart.setOption(option);
        // res.mapInfo
        // this.imgList = res.projectModel;
        // this.swiperList = res.bannerList;
      });
      // this.$http({
      //   url: 'api/index.index/digitalManagements',
      //   done: (res) => {

      //   },
      // });

      let mapFeatures = mapdata.features;

      mapFeatures.forEach((v) => {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        this.geoCoordMap[name] = v.properties.center;
      });
      echarts.registerMap('china', mapdata);

      let toolTipData = this.toolTipData;
    },
    convertData(data) {
      let res = [];

      for (let i = 0; i < data.length; i++) {
        let geoCoord = this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }

      return res;
    },
  },
};
</script>
<style lang="less" scoped>
.maps {
  margin-left: -40px;
}

.map {
  width: 100%;
  height: 100%;
}
</style>
